const urlConfigs = {
    createAssociate: 'api/v1/BasicAuth/CreateAssociate',
    validateWebAlias: 'api/v1/Basicauth/ValidateAssociateWebAlias',
    getAssociate: 'api/v1/BasicAuth/GetAssociate',
    updateAssociate: 'api/v1/Associate/UpdateAssociate',
    validateAssociateEmail: 'api/v1/Basicauth/ValidateAssociateEmail',
    createOrder: 'api/v1/Order/CreateOrder',
    generateToken: 'api/v1/Authorize/GenerateToken',
    calculatePrice: 'api/v1/Order/CalculateOrder',
    getAvailableMerchant: 'api/v1/Merchant/GetAvailableMerchant',
    getAssociateByWebAlias: 'api/v1/BasicAuth/GetAssociateByWebAlias',
    getIntercomHash: 'api/v1/Associate/GetIntercomHash',
    login: 'api/v1/Authorize/GenerateToken',
    getCompleteOrderDetails: 'api/v1/Order/GetCompleteOrderDetails',
    validatePhone: 'api/v1/BasicAuth/ValidateAssociatePhone',
    nmiTokenize: 'api/v1/Merchant/NMITokenize',
    getPayment: 'api/v1/Associate/GetPayment',
    getRegion: 'api/v1/Product/GetRegion',
    getProducts: 'api/v1/Product/GetProducts'
}
export default urlConfigs;
